import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IEditMatchListGroupPayload {
    matchListGroupId: string
    data: {
        name: string
    }
}

export interface IEditMatchListGroupState {
    status: string
    data: any
    errors: any
}

const initialState: IEditMatchListGroupState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const editMatchListGroup = createSlice({
    name: 'matchListGroup/edit',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IEditMatchListGroupPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const editMatchListGroupActions = editMatchListGroup.actions
export default editMatchListGroup.reducer
